export default {
    // API_URL: 'http://localhost:81/api',
    // API_URL: 'https://apidemo.localtunnel.me/api',
    API_URL: 'https://webstaticapi.omnicasa.com/api',
};
